/*eslint react/no-deprecated: 0*/ 
import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import * as MaterialUI from 'material-ui';
import { TextFieldF } from 'modules/forms/component';
import { FORM_RESERVA } from 'modules/forms/formConstants';
import { Field, change, formValueSelector } from 'redux-form/immutable';

import * as reservasActions from '../action';

const selector = formValueSelector(FORM_RESERVA);

@connect(store => ({
  viaje: store.getIn(['reservas', 'viaje']),
  acompanantes: selector(store, 'acompanantes'),
  reservaAcompanantes: store.getIn(['reservas', 'reserva', 'acompanantes'])
}))
export default class extends React.Component {
  componentWillReceiveProps(nextProps) {
    let viajeId = this.props.viaje.get('id');
    let newViajeId = nextProps.viaje.get('id');
    if(newViajeId !== viajeId && !this.props.edicion && this.props.acompanantes > 0)
    this.props.dispatch(reservasActions.setTemporal(newViajeId, this.props.acompanantes));
  }
  setAcompanante(cantSelect) {
    cantSelect++;
    if(this.props.acompanantes === cantSelect && this.props.edicion && cantSelect === 1){
      this.props.dispatch(reservasActions.setState({ reservaLlena: false }));
      cantSelect--;
    }else {
      if(this.props.acompanantes === cantSelect) cantSelect--;
      if (this.props.viaje && !this.props.reservaAcompanantes && !this.props.edicion) this.props.dispatch(reservasActions.setTemporal(this.props.viaje.get('id'), (cantSelect + 1)));
    }
    this.props.dispatch(change(FORM_RESERVA, 'acompanantes', cantSelect));
  }
  render() {
    const { acompanantes, cant } = this.props;
    return (
      <MaterialUI.Paper zDepth={1} className="container">
        <Row className="mt-10 p-20">
          <Field
            ref="acompanantes"
            name="acompanantes"
            component={TextFieldF}
            inputProps={{ className: 'hidden' }}
          />
          {[...Array(cant)].map((x, i) => (
            <Col md="2" key={i}>
              <MaterialUI.IconButton
                onTouchTap={() => this.setAcompanante(i)}
                iconClassName={acompanantes > i ? 'fa fa-user' : 'fa fa-user-o'}
              />
            </Col>
          ))}
        </Row>
      </MaterialUI.Paper>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/reservas/components/acompanantes.js